<template lang="pug">
div
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent)
    v-card
      v-card-title.py-4.px-5
        v-row(no-gutters align="center")
          v-col.shrink.mr-1
            v-btn.ml-n3(text icon @click="showModal = false" height)
              v-icon(color="basic800" :size="24") mdi-close
          v-col
            div.h6.basic800--text {{ $t('follow_up') }}
      v-divider.basic300
      v-layout.py-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      v-card-text.py-4.px-5(v-else)
        div.p1.primary--text {{ $t('follow_up_desc') }}
        v-row.mt-6(no-gutters align="center")
          v-col.pr-4.shrink
            eva-icon.mb-n2(name="bell-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="22" height="22")
          v-col
            div.c1.basic600--text {{ $t('follow_up_feature_1') }}
        v-row.mt-4(no-gutters align="center")
          v-col.pr-4.shrink
            eva-icon.mb-n2(name="flash-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="22" height="22")
          v-col
            div.c1.basic600--text {{ $t('follow_up_feature_2') }}
        v-row.mt-4(no-gutters align="center")
          v-col.pr-4.shrink
            eva-icon.mb-n2(name="trending-up-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="22" height="22")
          v-col
            div.c1.basic600--text {{ $t('follow_up_feature_3') }}

        v-card.basic200.pa-4.elevation-0.mt-4(v-if="showUpgrade")
          div.d-flex.align-center
            div.s1.primary--text {{ $t('growth_plan') }}
            v-spacer
            div.c2.textColorHint--text.text-decoration-line-through(v-if="prices.growth_slash") {{ prices.growth_slash[$currency.code] | displayPrice($currency) }}
            div.s1.success500--text.ml-1(v-if="prices.growth") {{ prices.growth[$currency.code] | displayPrice($currency) }}
          div.c1.textColorHint--text.text-right {{ $t('monthly') }}
          v-divider.basic400.my-4
          div.c1.basic600--text(v-if="prices.growth") {{ $t('growth_plan_desc_1', { price: $options.filters.displayPrice(prices.growth[$currency.code]) }) }}
          div.c1.basic600--text.mt-3 {{ $t('growth_plan_desc_2') }}:
          ul
            li.c1.basic600--text(v-if="prices.reseller") {{ $t('growth_feature_1', { price: $options.filters.displayPrice(prices.reseller[$currency.code]) }) }}
            li.c1.basic600--text(v-if="prices.bundle") {{ $t('growth_feature_2', { price: $options.filters.displayPrice(prices.bundle[$currency.code]) }) }}
            li.c1.basic600--text {{ $t('growth_feature_3') }}
            li.c1.basic600--text {{ $t('growth_feature_4') }}
            li.c1.basic600--text {{ $t('growth_feature_5') }}
          v-btn.button-AA-small.mt-5(block dark color="info500" small height="32" depressed :loading="isLoading" @click="upgradePlan") {{ $t('upgrade_to_growth') }}

        v-card.basic200.pa-4.elevation-0.mt-4
          div.d-flex.align-center
            div.s1.primary--text {{ !showUpgrade ? $t('follow_up') : $t('addon') }}
            v-spacer
            div.c2.textColorHint--text.text-decoration-line-through(v-if="prices.followup_slash") {{ prices.followup_slash[$currency.code] | displayPrice($currency) }}
            div.s1.success500--text.ml-1(v-if="prices.followup") {{ prices.followup[$currency.code] | displayPrice($currency) }}
          div.c1.textColorHint--text.text-right {{ $t('monthly') }}
          v-divider.basic400.my-4
          div.c1.basic600--text {{ $t('price_guarantee') }} : 
          div.c1.basic600--text.mt-3(v-if="prices.followup") {{ $t('price_guarantee_desc', { price: $options.filters.displayPrice(prices.followup[$currency.code]) }) }}
          v-btn.button-AA-small.mt-5(block dark color="info500" small height="32" depressed :loading="isLoading" @click="openConfirmationDialog = true") {{ $t('subscribe_as_add_on') }}
      
      .modal
        y-dialog(v-if="openConfirmationDialog" v-model='openConfirmationDialog', max-width='320')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('subscribe_follow_up') }}
            v-card-text.p2.primary500--text.px-4 {{ $t('subscribe_follow_up_confirmation') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click="openConfirmationDialog = false")
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='info500' depressed height=32 @click="subscribeFollowUp" dark :loading="isLoading")
                .button-AA-small.basic100--text {{ $t('confirm') }}

        y-dialog(v-if="openSuccessDialog" v-model='openSuccessDialog', max-width='270')
          v-card.pa-4.text-center
            div.p1.primary500--text {{ message }}
            v-btn.mt-3(color='transparent', text @click='closeDialog' block x-small)
              .button-Aa-small.primary400--text {{ $t('close') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'FollowUpSubscription',
  props: ['open', 'company', 'upgrade'],
  data: () => ({
    openSuccessDialog: false,
    openConfirmationDialog: false,
    isLoading: false,
    cards: [],
    message: '',
    isFetching: false,
    prices: {}
  }),
  computed: {
    ...mapState('subscriptions', ['yezzaSubscription', 'followUpSubscription']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    primaryCard () {
      if (this.cards.length === 0) {
        return null
      } else if (this.cards.length === 1) {
        return this.cards[0]
      } else {
        return this.cards.filter(c => c.primary)[0]
      }
    },
    showUpgrade () {
      if (this.upgrade) {
        return true
      }
      return false
    }
  },
  watch: {
  },
  mounted () {
    this.fetchPlanPrices()
    this.fetchCards()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPlanPrices () {
      this.isFetching = true
      this.$axios.get(`/subscription/plans`)
        .then(resp => {
          let growth = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_GROWTH_PLAN_MM'))
          if (growth) { this.$set(this.prices, 'growth', growth.contracts.find(i => i.code === 'YZ_GROWTH_PLAN_MM').prices) }
          if (growth) { this.$set(this.prices, 'growth_slash', growth.contracts.find(i => i.code === 'YZ_GROWTH_PLAN_MM').compare_at_prices) }
          let reseller = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM'))
          if (reseller) { this.$set(this.prices, 'reseller', reseller.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM').prices) }
          if (reseller) { this.$set(this.prices, 'reseller_slash', reseller.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM').compare_at_prices) }
          let bundle = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM'))
          if (bundle) { this.$set(this.prices, 'bundle', bundle.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM').prices) }
          if (bundle) { this.$set(this.prices, 'bundle_slash', bundle.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM').compare_at_prices) }
          let followup = resp.data.results.find(f => f.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM'))
          if (followup) { this.$set(this.prices, 'followup', followup.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM').prices) }
          if (followup) { this.$set(this.prices, 'followup_slash', followup.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM').compare_at_prices) }
          this.isFetching = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchCards () {
      this.isFetching = true
      this.$axios.get('/billing/cards/')
        .then(resp => {
          this.cards = resp.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    upgradePlan () {
      this.$router.push(`/admin/billing/subscription/?upgrade=followup`)
    },
    subscribeFollowUp () {
      this.isLoading = true
      let data = {
        company: this.company.id,
        contract: 'YZ_FOLLOW_UP_PLAN_MM',
        card: this.primaryCard ? this.primaryCard.id : null,
        terminate_existing: true
      }
      this.$axios.post(`/subscription/subscriptions/`, data)
        .then(resp => {
          this.$axios.post(`/subscription/bills/${resp.data.bill}/charge_card/`, data)
            .then(() => {
              this.message = 'Subscription successful'
              this.openSuccessDialog = true
            })
            .catch(() => {
              this.message = 'Subscription successful. Please complete the payment to avoid termination.'
              this.openSuccessDialog = true
            })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
          this.isLoading = false
        })
    },
    closeDialog () {
      this.openSuccessDialog = false
      this.showModal = false
      window.location.reload()
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "subscribe_successful": "Subscription successful",
    "subscribe_successful_complete_payment": "Subscription successful. Please complete the payment to avoid termination.",
    "subscribe_follow_up": "Subscribe Follow-up",
    "subscribe_follow_up_confirmation": "Are you sure you want to subscribe Follow-up?",
    "follow_up": "Follow-up",
    "follow_up_desc": "Increase your sales through an automated follow-up routine.",
    "follow_up_feature_1": "Scheduled notification to manage a good customer follow up routine.",
    "follow_up_feature_2": "Follow-up your potential sales with just one-click.",
    "follow_up_feature_3": "Track your follow-up performance in-a-glance on the dashboard",
    "price_guarantee": "Price Guarantee",
    "price_guarantee_desc": "If your sales from Follow-up is less than {price}, we’ll credit you back your Follow-up subscription",
    "monthly": "monthly",
    "subscribe_error": "Unable to subscribe. Please try different card or contact our support team.",
    "growth_plan": "Growth Plan",
    "growth_plan_desc_1": "Get access to all features in Growth. You monthly subscription will be {price}",
    "growth_plan_desc_2": "Features including but not limited to",
    "growth_feature_1": "Agent Commission System (worth {price})",
    "growth_feature_2": "Bundle Offers (worth {price})",
    "growth_feature_3": "Integration with WooCommerce & Shopify",
    "growth_feature_4": "10 WhatsApp Forms",
    "growth_feature_5": "10 Users",
    "upgrade_to_growth": "Upgrade to growth",
    "subscribe_as_add_on": "Subscribe as Add-on"
  },
  "id": {
    "subscribe_successful": "Berlangganan berjaya",
    "subscribe_successful_complete_payment": "Berlangganan berjaya. Harap selesaikan pembayaran untuk menghindari penghentian.",
    "subscribe_follow_up": "Berlangganan Follow-up",
    "subscribe_follow_up_confirmation": "Yakin ingin berlangganan Follow-up?",
    "follow_up": "Follow-up",
    "follow_up_desc": "Tingkatkan penjualan kamu melalui rutinitas tindak lanjut otomatis.",
    "follow_up_feature_1": "Pemberitahuan terjadwal untuk mengelola rutinitas tindak lanjut pelanggan yang baik.",
    "follow_up_feature_2": "Tindak lanjuti potensi penjualan kamu hanya dengan satu klik.",
    "follow_up_feature_3": "Lacak kinerja tindak lanjut kamu secara sekilas di dasbor.",
    "price_guarantee": "Jaminan Harga",
    "price_guarantee_desc": "Jika penjualan kamu dari Tindak lanjut kurang dari {price}, kami akan mengkredit kamu kembali langganan Follow-Up kamu",
    "monthly": "Bulanan",
    "subscribe_error": "Tidak dapat berlangganan. Silakan coba kartu lain atau hubungi tim support kami.",
    "growth_plan": "Growth Plan",
    "growth_plan_desc_1": "Dapatkan akses ke semua fitur di Growth. Langganan bulanan kamu akan menjadi {price}.",
    "growth_plan_desc_2": "Fitur termasuk namun tidak terbatas pada",
    "growth_feature_1": "Sistem Komisi Agen (senilai {price})",
    "growth_feature_2": "Penawaran Bundle (senilai {price})",
    "growth_feature_3": "Integrasi dengan WooCommerce dan Shopify",
    "growth_feature_4": "10 form WhatsApp",
    "growth_feature_5": "10 Pengguna",
    "upgrade_to_growth": "Tingkatkan ke Growth",
    "subscribe_as_add_on": "Berlangganan sebagai Add-on"
  }
}
</i18n>
